import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getLogByID } from './IMSLogviewer_api';
import Styles from './IMSLogDetails.module.scss';
import MaterialIcon from '@material/react-material-icon';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const PREFIX = 'IMSLogDetails';

const classes = {
	root: `${PREFIX}-root`,
	summary: `${PREFIX}-summary`,
};

const Root = styled('div')({
	[`& .${classes.root}`]: {
		borderRadius: '10px',
	},
	[`& .${classes.summary}`]: {
		backgroundColor: '#771b61',
		color: 'white',
		fontWeight: 'bold',
	},
});

const IMSLogDetails = props => {
	const history = useHistory();
	const logID = useParams().id;
	const [log, setLog] = useState({});

	useEffect(() => {
		//get log
		getLogByID(logID).then(data => setLog(data));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const navigateBack = () => {
		history.push('/IMSAdministration/Logviewer');
	};

	return (
		<Root className={Styles.container_main}>
			<div className={Styles.navigationContainer}>
				<div
					className={Styles.navigationItem}
					onClick={() => navigateBack()}
				>
					<MaterialIcon icon='arrow_back' className={Styles.icon} />
					Back To Log Viewer
				</div>
			</div>
			<div className={Styles.detailsContainer_main}>
				<Accordion className={classes.root} defaultExpanded={true}>
					<AccordionSummary
						expandIcon={
							<MaterialIcon
								icon='expand_more'
								className={Styles.icon}
							/>
						}
						aria-controls='panel1a-content'
						id='panel1a-header'
						className={classes.summary}
					>
						Log Entry Details
					</AccordionSummary>
					<AccordionDetails>
						<TableContainer component={Paper}>
							<Table
								size='medium'
								aria-label='Server Error Codes'
							>
								<TableBody>
									<TableRow>
										<TableCell
											component='td'
											scope='row'
											colSpan={1}
										>
											Log ID:
										</TableCell>
										<TableCell component='td' scope='row'>
											<strong>{log.LogEntryID}</strong>
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											Source:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.Source}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											Type:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.Type}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											Timestamp:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.CreateDate}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											Details:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.Details}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</AccordionDetails>
				</Accordion>
				<Accordion className={classes.root} defaultExpanded={true}>
					<AccordionSummary
						expandIcon={
							<MaterialIcon
								icon='expand_more'
								className={Styles.icon}
							/>
						}
						aria-controls='panel2a-content'
						id='panel2a-header'
						className={classes.summary}
					>
						Request Details
					</AccordionSummary>
					<AccordionDetails>
						<TableContainer component={Paper}>
							<Table
								size='medium'
								aria-label='Server Error Codes'
							>
								<TableBody>
									<TableRow>
										<TableCell
											component='td'
											scope='row'
											colSpan={1}
										>
											HTTP Method:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.HttpMethod}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											URL:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.Url}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											URL Referrer:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.UrlReferrer}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											User Agent:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.UserAgent}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											User Host Address:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.UserHostAddress}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='td' scope='row'>
											User Host Name:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.UserHostName}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</AccordionDetails>
				</Accordion>
				<Accordion className={classes.root} defaultExpanded={true}>
					<AccordionSummary
						expandIcon={
							<MaterialIcon
								icon='expand_more'
								className={Styles.icon}
							/>
						}
						aria-controls='panel3a-content'
						id='panel3a-header'
						className={classes.summary}
					>
						Session Details
					</AccordionSummary>
					<AccordionDetails>
						<TableContainer component={Paper}>
							<Table
								size='medium'
								aria-label='Server Error Codes'
							>
								<TableBody>
									<TableRow>
										<TableCell
											component='td'
											scope='row'
											colSpan={1}
										>
											Session ID:
										</TableCell>
										<TableCell component='td' scope='row'>
											{log.SessionID}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</AccordionDetails>
				</Accordion>
			</div>
		</Root>
	);
};

export default IMSLogDetails;
